import React from "react";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
  Alert
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


const ReferralRewardTable = ({
  rewards,
  onAddClick,
  onEditClick,
  onDeleteClick,
  loading,
  error,
  refreshFlag,
  setRefreshFlag
}) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  const handleExport = () => {
  if (!rewards || rewards.length === 0) {
    alert("No data to export!");
    return;
  }

  // Prepare data for Excel
  const exportData = rewards.map((reward, index) => ({
    "S.No": index + 1,
    "No. of Users": reward.no_of_users,
    "Credit Points": reward.credit_points || 'N/A',
    "Start": reward.created_at,
    "End": reward.disabled_at
  }));

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "ReferralRewards");

  // Generate buffer and save
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(dataBlob, "ReferralRewards.xlsx");
};

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        Error loading referral rewards: {error}
      </Alert>
    );
  }

  return (
    <>
<Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
  <Button 
    variant="contained" 
    color="success" 
    onClick={handleExport}
  >
    Export
  </Button>

  <Button 
    variant="contained" 
    color="primary" 
    startIcon={<AddIcon />}
    onClick={onAddClick}
  >
    Add Reward
  </Button>
</Box>


      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: '#1976d2' }}>
            <TableRow>
              <TableCell sx={{ color: 'white' }}>S.No</TableCell>
              {/* <TableCell sx={{ color: 'white' }}>User ID</TableCell> */}
              <TableCell sx={{ color: 'white' }}>No. of Users</TableCell>
              <TableCell sx={{ color: 'white' }}>Credit Points</TableCell>
              {/* <TableCell sx={{ color: 'white' }}>Actions</TableCell> */}
              <TableCell sx={{ color: 'white' }}>Start</TableCell>
              <TableCell sx={{ color: 'white' }}>End</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rewards.map((reward, index) => (
              <TableRow key={reward.rew_id}>
                <TableCell>{index + 1}</TableCell>
                {/* <TableCell>{reward.user_id}</TableCell> */}
                <TableCell>{reward.no_of_users}</TableCell>
                <TableCell>
                  {reward.credit_points || (
                    <Typography variant="body2" color="textSecondary">
                      N/A
                    </Typography>
                  )}
                </TableCell>
                 <TableCell>{reward.created_at}</TableCell>
                <TableCell>{reward.disabled_at}</TableCell>
                {/* <TableCell>
                  <IconButton 
                    color="primary" 
                    onClick={() => onEditClick(reward)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton 
                    color="error"
                    onClick={() => onDeleteClick(reward)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ReferralRewardTable;